import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../../../model/RootStoreContext';
import { ISelection } from '../../../model/selections/Selection';
import { useParams } from 'react-router-dom';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useSelectionResult {
    isLoaded: boolean;
    selection: ISelection | null;
}

export const useSelection = (refreshFlag: boolean) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();
    const { selectionId } = useParams<{ selectionId: string }>();

    const [result, setResult] = useState<useSelectionResult>({
        isLoaded: false,
        selection: null
    });

    useEffect(() => {
        setResult({ isLoaded: false, selection: null });

        if (selectionId) {
            rootStore.selectionStore.getSelection(parseInt(selectionId))
                .then((selection) => {
                    rootStore.selectionStore.setCurrentSelection(selection.id);
                    setResult({
                        isLoaded: true,
                        selection: selection
                    });
                })
                .catch(e => publishNotification({
                    text: 'Error loading selection',
                    canClose: true
                }));
        } else {
            setResult({
                isLoaded: true,
                selection: rootStore.selectionStore.addSelection()
            });
        }
        return () => {
            rootStore.selectionStore.clearCurrentSelection();
        };
    }, [rootStore.selectionStore, publishNotification, selectionId, refreshFlag]);

    return result;
};
